import { Button, Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, FormCheckbox, Heading, Text } from "@sentricmusic/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useUIStateStore } from "@/store/uiStateStore";

type DeleteRecordingModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

function DeleteRecordingModal({ isOpen, onClose, onConfirm }: DeleteRecordingModalProps) {
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);
  const { t } = useTranslation(["songs", "common"]);
  const isTunecore = useUIStateStore(state => state.isTunecore);

  const handleConfirm = (): void => {
    if (doNotShowAgain) {
      localStorage.setItem("showDeleteRecordingWarning", "false");
    }
    onClose();
    onConfirm();
  };

  return (
    <Dialog open={isOpen} onOpenChange={open => !open && onClose()}>
      <DialogContent className="max-w-md">
        <div className="flex flex-col gap-4">
          <DialogHeader className="text-left">
            <DialogTitle asChild>
              <Heading as="h3">{t("songs:delete-recording-modal-header")}</Heading>
            </DialogTitle>
            <DialogDescription asChild>
              <Text as="p">{t("songs:delete-recording-modal-text")}</Text>
            </DialogDescription>
          </DialogHeader>
          <FormCheckbox
            id="doNotShowAgainRecording"
            label={String(t("common:dont-show-again"))}
            checked={doNotShowAgain}
            onCheckedChange={setDoNotShowAgain}
          />
          <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
            <Button variant={isTunecore ? "primary" : "secondary"} label={String(t("common:take-me-back-button"))} onClick={onClose} />
            <Button variant="destructive" label={String(t("songs:delete-work-confirm-button"))} onClick={handleConfirm} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default DeleteRecordingModal;
